<fab-header [appName]="appName" (sidenavToggle)="toggleSideBar()">
  <span class="current-date">{{currentDate| date:'dd-MMM-yyyy'}}&nbsp;</span>
  <button mat-icon-button color="primary" (click)="onSubmit()">
    <mat-icon title='Logout'>logout</mat-icon>
  </button>
  <fab-user-info *ngIf="isUserAuthorized" [user]="user"></fab-user-info>
</fab-header>
<fab-sidenav [isOpen]="sidenavVisible" *ngIf="isUserAuthorized;else elseBlock"
             [navItems]="this.navItems">
  <router-outlet></router-outlet>
</fab-sidenav>

<ng-template #elseBlock >
  <div class="section-header" *ngIf="!isUserAuthorized">
    Usuario no existe en el sistema, por favor contacte al administrador.
  </div>
</ng-template>
<app-footer></app-footer>

